// matches whether a string represents an IP in designated RFC1918 private ranges
export const PRIVATE_IP_REGEX = /^\s?(10\.)|(172\.1[6-9]\.)|(172\.2[0-9]\.)|(172\.3[0-1])|(192\.168\.)/;
